<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div class="">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="用户状态：">
              <el-input v-model="searchForm.webSearchStr" placeholder="请输入用户昵称/手机号搜索" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="商品搜索：">
              <el-input v-model="searchForm.name" placeholder="请输入商品名称搜索" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="时间筛选：">
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div>
        <el-table
          border
          :data="infoList"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="orderNo"
            label="订单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickPhone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="left"
            prop="orderGoodsPageVoList"
            width="450"
            label="商品信息">
            <template slot-scope="scope">
              <div class="" v-for="(item,index) in scope.row.orderGoodsPageVoList" :key="index">
                <el-image
                  style="width: 32px;"
                  :src="item.thumb"
                  :preview-src-list="[item.thumb]"
                  fit="contain">
                  </el-image>
                  <span>{{item.goodsName}}-{{item.specName}}</span>
                  <span>x{{item.goodsNumber}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="useIntegral"
            label="兑换积分">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="兑换时间">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryWebIntegralOrderPageList } from '@/api/integral'
export default {
  name: 'IntegralMallOrder',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      searchForm: {
        name:'',
        webSearchStr:'',
        date:['', '']
      },
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      infoId:''
    }
  },
  mounted () {
    var that = this;
    that.getInfoList();
  },
  created() {

  },
  methods: {
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let webSearchStr = that.searchForm.webSearchStr
      let searchName = that.searchForm.name
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      queryWebIntegralOrderPageList({ goodsName: searchName, webSearchStr: webSearchStr, startCreateDate: startDate, endCreateDate: endDate, pageNum: page, pageSize: that.limitLength }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/integralMall/Order.vue